import gsap from 'gsap';

var ANIM_DURATION = 0.45;
var ANIM_EASE_OPEN = 'power2.out';
var ANIM_EASE_CLOSE = 'power2.inOut';

var AvailabilityTable = function (options) {

	this.options = {
		$el: false,
		baseClass: 'section_availability-table',
	};

	$.extend(true, this.options, options);

	this.panels = [];
	this._onResize = null;

};

AvailabilityTable.prototype.init = function () {

	var self = this;
	var $root = this.options.$el;
	var $accordions = $root.find('.accordion1_component');

	if (!$accordions.length) {
		return;
	}

	$accordions.each(function (index) {
		var $comp = $(this);
		var panel = {
			$comp: $comp,
			$top: $comp.find('.accordion1_top'),
			$bottom: $comp.find('.accordion1_bottom'),
			$listWrap: $comp.find('.availability-table_list-wrap'),
			$icon: $comp.find('.accordion1_icon'),
			isOpen: index === 0,
		};

		self.panels.push(panel);

		panel.$top.on('click', function () {
			if (panel.isOpen) {
				self.closePanel(panel);
			} else {
				self.openPanel(panel);
			}
		});
	});

	this.panels.forEach(function (panel, i) {
		self.setInitialPanelState(panel, i === 0);
	});

	this._onResize = _.debounce(function () {
		self.refreshOpenHeights();
	}, 150);

	$(window).on('resize.availabilityTable', this._onResize);

};

/**
 * While markup loads expanded, measure each bottom then collapse all except the first.
 */
AvailabilityTable.prototype.setInitialPanelState = function (panel, isFirst) {

	var bottom = panel.$bottom[0];
	var icon = panel.$icon[0];

	gsap.killTweensOf([bottom, icon]);

	gsap.set(bottom, { overflow: 'hidden' });

	if (isFirst) {
		panel.isOpen = true;
		panel.$comp.addClass('is-open');
		gsap.set(icon, { rotation: 0, transformOrigin: '50% 50%' });
		gsap.set(bottom, { height: 'auto', opacity: 1 });
	} else {
		panel.isOpen = false;
		panel.$comp.removeClass('is-open');
		gsap.set(icon, { rotation: -90, transformOrigin: '50% 50%' });
		gsap.set(bottom, { height: 0, opacity: 0 });
		panel.$listWrap.css('overflow', 'hidden');
	}

};

AvailabilityTable.prototype.openPanel = function (panel) {

	var bottom = panel.$bottom[0];
	var icon = panel.$icon[0];

	gsap.killTweensOf([bottom, icon]);

	panel.$listWrap.css('overflow', 'hidden');
	gsap.set(bottom, { overflow: 'hidden' });

	gsap.set(bottom, { height: 'auto' });
	var target = bottom.scrollHeight;
	gsap.set(bottom, { height: 0, opacity: 0 });

	panel.isOpen = true;
	panel.$comp.addClass('is-open');

	gsap.to(bottom, {
		height: target,
		opacity: 1,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_OPEN,
		onComplete: function () {
			gsap.set(bottom, { height: 'auto' });
			panel.$listWrap.css('overflow', '');
		},
	});

	gsap.to(icon, {
		rotation: 0,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_OPEN,
		transformOrigin: '50% 50%',
	});

};

AvailabilityTable.prototype.closePanel = function (panel) {

	var bottom = panel.$bottom[0];
	var icon = panel.$icon[0];

	gsap.killTweensOf([bottom, icon]);

	panel.$listWrap.css('overflow', 'hidden');
	gsap.set(bottom, { overflow: 'hidden' });

	var currentH = bottom.scrollHeight;
	gsap.set(bottom, { height: currentH, opacity: 1 });

	panel.isOpen = false;
	panel.$comp.removeClass('is-open');

	gsap.to(bottom, {
		height: 0,
		opacity: 0,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_CLOSE,
	});

	gsap.to(icon, {
		rotation: -90,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_CLOSE,
		transformOrigin: '50% 50%',
	});

};

/**
 * When the viewport changes, open panels use height: auto — only normalize if GSAP left a numeric height.
 */
AvailabilityTable.prototype.refreshOpenHeights = function () {

	this.panels.forEach(function (panel) {
		if (!panel.isOpen) {
			return;
		}
		var bottom = panel.$bottom[0];
		if (!gsap.getTweensOf(bottom).length) {
			gsap.set(bottom, { height: 'auto' });
		}
	});

};

export default AvailabilityTable;
